import {replaceSpecialCharacters} from './StringUtils';

const noGoFirstNames = ['JOSE', 'J', 'J.', 'MARIA', 'MA.', 'MA', 'DA', 'DAS', 'DE', 'DEL', 'DER', 'DI', 'DIE', 'DD',
    'EL', 'LA', 'LOS', 'LAS', 'LE', 'LES', 'MAC', 'MC', 'VAN', 'VON', 'Y'];
const noGoLastNames = ['DA', 'DAS', 'DE', 'DEL', 'DER', 'DI', 'DIE', 'DD', 'EL', 'LA', 'LOS', 'LAS', 'LE', 'LES',
    'MAC', 'MC', 'VAN', 'VON', 'Y'];
const noGoWords = ['BACA', 'BAKA', 'BUEI', 'BUEY', 'CACA', 'CACO', 'CAGA', 'CAGO', 'CAKA', 'CAKO', 'COGE', 'COGI',
    'COJA', 'COJE', 'COJI', 'COJO', 'COLA', 'CULO', 'FALO', 'FETO', 'GETA', 'GUEI', 'GUEY', 'JETA', 'JOTO', 'KACA',
    'KACO', 'KAGA', 'KAGO', 'KAKA', 'KAKO', 'KOGE', 'KOGI', 'KOJA', 'KOJE', 'KOJI', 'KOJO', 'KOLA', 'KULO', 'LILO',
    'LOCA', 'LOCO', 'LOKA', 'LOKO', 'MAME', 'MAMO', 'MEAR', 'MEAS', 'MEON', 'MIAR', 'MION', 'MOCO', 'MOKO', 'MULA',
    'MULO', 'NACA', 'NACO', 'PEDA', 'PEDO', 'PENE', 'PIPI', 'PITO', 'POPO', 'PUTA', 'PUTO', 'QULO', 'RATA', 'ROBA',
    'ROBE', 'ROBO', 'RUIN', 'SENO', 'TETA', 'VACA', 'VAGA', 'VAGO', 'VAKA', 'VUEI', 'VUEY', 'WUEI', 'WUEY'];
const specialChars = ['/', '-', '.'];

const processString = (str) => {
    const translate = {
        á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u', ü: 'u',
        Á: 'A', É: 'E', Í: 'I', Ó: 'O', Ú: 'U', Ü: 'U'
    };
    const translateRe = /[áéíóúüÁÉÍÓÚÜ]/g;
    return replaceSpecialCharacters(str.trim(), translateRe, translate).toUpperCase();
};

const checkNames = (names) => {
    const splitted = names.split(' ');
    if (splitted.length === 1) {
        return splitted[0].charAt(0).match(/[a-z]/i) ? splitted[0] : 'X';
    }
    const arrayToCompare = noGoFirstNames;

    const name = splitted.reduce((total, currentValue) => total === '' ?
        !arrayToCompare.includes(currentValue) ? currentValue : total : total, '');
    return name === '' ? splitted[1].charAt(0).match(/[a-z]/i) ? splitted[1] : 'X' :
        name.charAt(0).match(/[a-z]/i) ? name : 'X';
};

const checkLastNames = (names) => {
    const splitted = names.split(' ');
    if (splitted.length === 1) {
        return splitted[0];
    }
    const arrayToCompare = noGoLastNames;

    return splitted.reduce((total, currentValue) => total === '' ?
        !arrayToCompare.includes(currentValue) ? currentValue : total : total, '');
};

const getFirstLetterLastName = (lastName) => {
    const firstLetter = lastName.charAt(0);
    return firstLetter.match(/[a-z]/i) ? firstLetter : 'X';
};

const getFirstVowelLastName = (lastName) => {
    const lastNameArray = lastName.split('');
    lastNameArray.shift();
    const firstVowel = lastNameArray.find(char => (/^[AEIOU]$/i).test(char));
    return firstVowel ? firstVowel : 'X';
};

const rfcProcessName = name => name.substr(0, 1);

const rfcProcessLastName = (lastName) => {
    const firstLetter = getFirstLetterLastName(lastName);
    const secondLetter = lastName.substr(1, 1);
    const firstVowel = specialChars.includes(secondLetter) ? 'X' : getFirstVowelLastName(lastName);
    return `${firstLetter}${firstVowel}`;
};

const rfcProcessSecondLastName = secondLastName => secondLastName ? getFirstLetterLastName(secondLastName) : 'X';

// tslint:disable:prefer-template
const processBirthday = (birthday) => {
    const birthArray = birthday.split('-');
    const year = (' ' + birthArray[2]);
    const month = ('0' + birthArray[1]);
    const day = ('0' + birthArray[0]);
    return `${year.slice(-2)}${month.slice(-2)}${day.slice(-2)}`;
};

const processRFC = (rfc) => {
    if (noGoWords.includes(rfc)) {
        return rfc.substr(0, 1) + 'X' + rfc.substr(2);
    }
    return rfc;
};

export const calculateRFC = (lastName, secondLastName, firstName, secondName = '', birthday) => {
    const sndName = !secondName ? '' : secondName;
    if (lastName === '' || secondLastName === '' || firstName === '' || birthday === '' || birthday === undefined) {
        return '';
    }

    const processedNames = rfcProcessName(checkNames(processString(`${firstName} ${sndName}`)));
    const processedLastName = rfcProcessLastName(checkLastNames(processString(lastName)));
    const processedSecondLastName = rfcProcessSecondLastName(checkLastNames(processString(secondLastName)));
    const processedBirthday = processBirthday(birthday);
    return processRFC(`${processedLastName}${processedSecondLastName}${processedNames}`) + processedBirthday;
};